import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const root = css`
  margin-bottom: ${spacing.md}px;
  text-align: center;

  h3 {
    margin: 0 0 ${spacing.base}px 0;
    ${responsiveText.HEADING.SM};
    color: var(--brand-bluple-base);
  }

  p {
    margin: 0 0 ${spacing.md}px 0;
    ${responsiveText.BODY.SM};
    color: var(--neutral-black-base);
  }

  hr {
    margin: ${spacing.lg}px auto;
    width: 100px;
    border: none;
    height: 1px;
    background-color: var(--brand-bluple-30);
  }

  small {
    display: block;
    ${responsiveText.BODY.XS};
    color: var(--brand-bluple-70);
  }
`;
